module.exports = __webpack_public_path__ + "img/red_068.a9953882.png";